// extracted by mini-css-extract-plugin
module.exports = {"bedroom":"shimmer_bedroom__1knE7","bedroomImage":"shimmer_bedroomImage__2Ej5a","placeholderShimmer":"shimmer_placeholderShimmer__1KYi7","title":"shimmer_title__1H8_m"};